// ── Company Info ─────────────────────────────────────────────
export const COMPANY = {
  name:      'AL-AMANAT',
  fullName:  'AL-AMANAT Travels & Services LTD',
  tagline:   'Your trusted partner for Hajj, Umrah & world travel',
  phone1:    '08060467676',
  phone2:    '07089451747',
  whatsapp:  '7089451747',
  email:     'alamanttravels45@gmail.com',
  facebook:  'https://www.facebook.com/AlamanatTravels?mibextid=ZbWKwL',
  instagram: 'https://instagram.com/alamanattravels?igshid=ZGUzMzM3NWJiOQ==',
};

export const WA_LINK =
  `https://api.whatsapp.com/send?phone=${COMPANY.whatsapp}&text=I%20am%20ready%20to%20embark%20on%20my%20journey%20with%20your%20company`;

// ── Hero Slides ───────────────────────────────────────────────
export const heroSlides = [
  {
    title:    'Umrah Packages',
    subtitle: 'December 2026 & Ramadan 2027 Pilgrimage Bookings Open',
    tag:      'Sacred Pilgrimage Deals',
    image:    'umrah_pilgrimage_makkah_1791488683105.jpg',
  },
  {
    title:    'AL-AMANAT',
    subtitle: 'Travels & Services LTD',
    tag:      'Trusted Since Over A Decade',
    image:    'masjibNew.jpg',
  },
  {
    title:    'Ticket Booking',
    subtitle: 'Secure Your Flights Today',
    tag:      'Domestic & International',
    image:    'medina.jpg',
  },
  {
    title:    'Visa Processing',
    subtitle: 'Efficient Visa Assistance',
    tag:      'Hassle-Free Documentation',
    image:    'masjid.jpg',
  },
  {
    title:    'Hotel Booking',
    subtitle: 'Book · Stay · Enjoy',
    tag:      'Comfort At Every Destination',
    image:    'paris.jpg',
  },
];

// ── Services ──────────────────────────────────────────────────
export const services = [
  {
    id:    1,
    icon:  'FaRoute',
    title: 'Travel Guide',
    desc:  'Our expert guides craft personalised itineraries so every journey is stress-free and unforgettable.',
  },
  {
    id:    2,
    icon:  'FaTicketAlt',
    title: 'Ticket Booking',
    desc:  'Domestic and international air tickets booked quickly and efficiently at competitive fares.',
  },
  {
    id:    3,
    icon:  'FaHotel',
    title: 'Hotel Booking',
    desc:  'From budget stays to five-star comfort — we secure accommodation that fits your preference and pocket.',
  },
  {
    id:    4,
    icon:  'FaPassport',
    title: 'Visa Processing',
    desc:  'We handle the paperwork so you can focus on packing. Fast, accurate visa assistance for any destination.',
  },
];

// ── Hajj Packages ─────────────────────────────────────────────
export const hajjCampaign = {
  year: '2027',
  paymentDeadline: '30th September 2026',
  departure: '5th & 6th May 2027',
  returnDate: '24th May 2027',
  specialArrangements: [
    { title: 'First & Business Class', detail: 'Subject to airline availability.' },
    { title: 'Stay Single in a Room', detail: 'Subject to availability.' },
    { title: 'Upgrade Your Tent', detail: 'Mina & Arafat upgrade from ₦3,500,000, subject to availability.' },
  ],
};

export const hajjPackages = [
  {
    id:       1,
    name:     'Basic Package',
    badge:    'Selling Fast',
    options: [
      { label: '4 in a Room', price: '₦8,500,000' },
      { label: '2 in a Room', price: '₦9,800,000', note: 'Allows husband & wife to share a room' },
    ],
    features: [
      '3-star hotel within 15 minutes walk to Haram in Makka',
      '3-star hotel within 5 minutes walk to Haram in Madinah',
      'Return economy airline ticket',
      'Hajj Visa Processing',
      'Two Meals Daily (Breakfast & Dinner)',
      'Local transport in Makkah & Madinah',
      'Guided Visits to Historical Sites',
      'Tent accommodation in Mina & Arafat',
    ],
  },
  {
    id:       2,
    name:     'Standard Package',
    badge:    'Good Value',
    // highlight: true,
    options: [
      { label: '4 in a Room', price: '₦16,300,000' },
      { label: '2 in a Room', price: '₦18,685,000' },
    ],
    features: [
      '5-star hotel within 7 minutes walk to Al-Haram in Makkah',
      '5-star hotel within 5 minutes walk to Al-Haram in Madinah',
      'Return economy airline ticket',
      'Hajj Visa Processing',
      'Two Meals Daily (Breakfast & Dinner)',
      'Local transport in Makkah & Madinah',
      'Guided Visits to Historical Sites',
      'Tent accommodation in Mina & Arafat',
    ],
  },
  {
    id:       3,
    name:     'Premium Package',
    badge:    'Best Value',
    highlight: true,
    options: [
      { label: '4 in a Room', price: '₦23,468,000' },
      { label: '2 in a Room', price: '₦28,450,000' },
    ],
    features: [
      '5-star hotel directly opposite Haram in Makkah (Hilton)',
      '5-star hotel in Madinah (PullMan ZamZam / Hilton)',
      'Return economy airline ticket',
      'Visa procurement',
      'Two Buffet Meals Daily (Breakfast & Dinner)',
      'Local transport in Makkah & Madinah',
      'Guided Visits to Historical Sites',
      'Tent accommodation in Mina & Arafat',
    ],
  },
];

// ── Umrah Packages ────────────────────────────────────────────
export const umrahPackages = [
  {
    id: 1,
    name: 'December 2026',
    price: '₦4,500,000',
    subtitle: 'End of Year Spiritual Journey',
    features: [
      'Return airline ticket',
      'Saudi Umrah visa',
      'Hotel accommodation',
      'Ground transportation',
      'Guided historical Ziyarah',
    ],
  },
  {
    id: 2,
    name: 'Ramadan 2027',
    price: '₦5,500,000',
    subtitle: 'Blessed Month Pilgrimage',
    features: [
      'Return airline ticket',
      'Saudi Umrah visa',
      'Hotel accommodation',
      'Ground transportation',
      'Guided historical Ziyarah',
    ],
  },
];

// ── Testimonials ─────────────────────────────────────────────
export const testimonials = [
  {
    id:         1,
    name:       'Alhaja Bola Yusuf Manjo',
    role:       'Operations Manager, Polaris Bank',
    quote:      'Booking through AL-AMANAT was incredible! The staff was knowledgeable, friendly and made the entire process stress-free. Thanks to them, I had the trip of a lifetime.',
    image:      'client1.jpg',
  },
  {
    id:         2,
    name:       'Alhaji Babatunde Olopo',
    role:       'MD, Fatuns BDC & Fatuns Motor',
    quote:      'I highly recommend AL-AMANAT Travels. They exceeded my expectations, crafting a personalised itinerary and taking care of every detail. Their attention to detail is remarkable.',
    image:      'client2.jpg',
  },
];

// ── Branch Offices ────────────────────────────────────────────
export const branches = [
  {
    id:      1,
    city:    'Lagos (Head Office)',
    address: '611 Agege Motor Road, Shogunle Bus Stop, Ikeja, Lagos.',
    isHQ:    true,
  },
  {
    id:      2,
    city:    'Ilorin Branch',
    address: '13, Abdulquadri Road GRA, Ilorin, opposite National Museum GRA, Ilorin.',
  },
  {
    id:      3,
    city:    'Ijebu Ode Branch',
    address: '66 Ibadan Road, between Sky Bank & Stanbic Bank, Ijebu Ode, Ogun.',
  },
  {
    id:      4,
    city:    'Abeokuta Branch',
    address: 'Ita Osin Central Mosque, Abeokuta, Ogun.',
  },
  {
    id:      5,
    city:    'Osogbo Branch',
    address: 'Wafo Shopping Complex, opposite FCMB Bank, Olosan Bus Stop, Ibadan Road, Osogbo, Osun.',
  },
  {
    id:      6,
    city:    'Ibadan Branch',
    address: 'Kan Ekun Plaza, behind NNPC Filling Station, Akala Road, Ibadan, Oyo.',
  },
];

// ── Stats ────────────────────────────────────────────────────
export const stats = [
  { value: '10+',   label: 'Years Experience' },
  { value: '1,000+', label: 'Happy Pilgrims' },
  { value: '6',     label: 'Branch Offices' },
  { value: '50+',   label: 'Destinations' },
];

// ── Certifications ───────────────────────────────────────────
export const certifications = [
  {
    name: 'IATA',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684245136/AGIKgqOPB5bjsMVz4SC9gCKJ5Qf-rfk75aRhMmJxKWoX6g_s900-c-k-c0x00ffffff-no-rj_uupifk.jpg',
  },
  {
    name: 'NANTA',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684245197/NANTA-960x698_kdh9d9.jpg',
  },
  {
    name: 'NAHCON',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684245310/ARBm59zA_400x400_utlvoo.jpg',
  },
  {
    name: 'CAC',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684245401/E-XHYA_VIAI6rng_ag41ch.png',
  },
  {
    name: 'Member',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684302984/ryoSiNn8_400x400_xjaz2q.png',
  },
  {
    name: 'ICAO',
    url:  'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684309475/800px-International_Civil_Aviation_Organization_logo.svg_akfhuy.png',
  },
];

// ── Gallery ──────────────────────────────────────────────────
export const galleryItems = [
  { type: 'image', src: 'https://res.cloudinary.com/dvo8xhx6r/image/upload/v1684245071/PHOTO-2023-04-21-03-14-19_dmodsc.jpg', alt: 'Al-Amanat Group' },
  { type: 'video', src: 'https://res.cloudinary.com/dvo8xhx6r/video/upload/v1684245091/VIDEO-2023-03-16-19-51-32_r6urhm.mp4' },
  { type: 'video', src: 'https://res.cloudinary.com/dvo8xhx6r/video/upload/v1683756867/0510_1_xrcmuj.mov' },
  { type: 'video', src: 'https://res.cloudinary.com/dvo8xhx6r/video/upload/v1684303965/2a20bd3c-3d40-4898-a500-daab70cda305_kliru5.mp4' },
  { type: 'video', src: 'https://res.cloudinary.com/dvo8xhx6r/video/upload/v1683756871/0510_3_xvyc1d.mov' },
  {type: 'video', src: 'https://res.cloudinary.com/dvo8xhx6r/video/upload/du_14/v1787484513/gxciz0e1doyvwska5x90.mp4'}
];
